import { createSlice } from '@reduxjs/toolkit';
import { apiURL } from '../Util/apiURL';
import { postItemThunk } from '../lib/default-post-item';
import { asignReducer } from '../lib/shared-reducers';
import { addDays } from '../Util/get-date';

const apiHOST = apiURL();
const initialState = {
  factura: '',
  fechaFactura: '',
  fechaVencimiento: '',
  proveedor: '',
  iva: false,
};

export const insertCuentaPorPagar = postItemThunk(
  'crearCuentaPorPagar/insertCuentaPorPagar',
  `${apiHOST}cuentas-por-pagar/`,
  'cuentas-por-pagar',
);

const createCuentaPorPagarSlice = createSlice({
  name: 'createCuentaPorPagar',
  initialState: initialState,
  reducers: {
    change(state, action) {
      switch (action.payload.field) {
        case 'factura':
          state.factura = action.payload.value;

          break;

        case 'fechaFactura':
          state.fechaFactura = action.payload.value;
          break;

        case 'fechaVencimiento':
          const { fechaFactura, sliceState } = action.payload.value;
          state.fechaVencimiento = addDays(fechaFactura, sliceState.proveedor.diasCredito);
          break;

        case 'vigente':
          state.enCalidadDe = action.payload.value;
          break;
        case 'reset':
          state.fechaFactura = '';
          state.fechaVencimiento = '';
          break;

        case 'iva':
          state.iva = action.payload.value;
          break;

        default:
      }
    },
    asignReducer,
  },
  extraReducers: (builder) => {},
});

export default createCuentaPorPagarSlice;

export const createCuentaPorPagarActions = createCuentaPorPagarSlice.actions;
